// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UserAccessLevel from "../entity/UserAccessLevel.bs.js";
import * as UserTypeApiModel from "../api-model/UserTypeApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function apiModelToState(res) {
  return {
          access_level: UserAccessLevel.fromString(res.access_level)
        };
}

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(UserTypeApiModel.t_decode(json), "UserTypeEntityMapper.res");
  return {
          access_level: UserAccessLevel.fromString(res.access_level)
        };
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
